import { Flex, Text } from '@chakra-ui/react';
import { getInitials } from '@texas/utils/helpers/commonHelpers';
import {
  BranchIdentifier,
  getBranchColor,
} from '@texas/utils/helpers/texas/branchHelpers';
import { AngularNavLink } from '../shared/AngularNavLink';

interface UserNameCellProps {
  id: number;
  name: string;
  branchIdentifier: string | null;
}

export function UserNameCell({
  branchIdentifier,
  id,
  name,
}: UserNameCellProps) {
  return (
    <AngularNavLink
      navobj={{ userId: id }}
      textDecoration="none"
      to="users.detail"
      variant="unstyled"
    >
      <Flex align="center" gap="11px" minW={0}>
        <Flex
          align="center"
          bg={getBranchColor((branchIdentifier ?? '000') as BranchIdentifier)}
          color="white"
          flexShrink={0}
          fontSize="11px"
          fontWeight="bold"
          h="34px"
          justify="center"
          w="34px"
        >
          {getInitials(name)}
        </Flex>
        <Text fontWeight="semibold" overflow="hidden" textOverflow="ellipsis">
          {name}
        </Text>
      </Flex>
    </AngularNavLink>
  );
}
